import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_LOCATIONBYCOMPID } from "../../../utils/constants";
import { LocationInterface } from "../../../models/TicketModule/Location";
import locationService from "../../../services/ticketService/locationService";

const useLocationsByCompId = (
  page: number,
  pageSize: number,
  companyId: string | undefined
) =>
  useQuery<LocationInterface[], Error>({
    queryKey: [
      CACHE_KEY_LOCATIONBYCOMPID,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
      companyId,
    ],
    queryFn: () => locationService.GetAllWithCompId(page, pageSize, companyId),
  });

export default useLocationsByCompId;
